export default function getApiUrl(path: string) {
    return new URL((process.env.REACT_APP_API_URL || '') + path, window.location.href).toString();
}